export default {"src":"/_next/static/media/errorFeedbackMessage.aa6c47a4.svg","height":50,"width":49};